module.exports = __webpack_public_path__ + "img/Aquarius.1fb0896e.png";